// extracted by mini-css-extract-plugin
export default {"header":"ShiftsPage_header__BFrQK","fadeIn":"ShiftsPage_fadeIn__ABnc-"};